<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-22 00:43:03
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-28 09:18:12
 * @FilePath: \H5\src\views\ewm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
  <div class="box">
    <div class="box-pic">
      <img :src="list.qrcode_info.qrcode" alt="" style="width: 100%; height: 100%;">
    </div>
    <div class="info">
      {{ list.qrcode_info.explain }}
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        list: null
      };
    },
    created() {
      this.list = JSON.parse(
      window.localStorage.getItem("reData")
    );
    }
  }
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  margin: 60px auto;
  width: 222px;
  height: 600px;
  margin-bottom: 250px;
  .box-pic {
    width: 222px;
    height: 218px;
  }
  .info {
    margin-top: 20px;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 32px;
    color: #00644C;
    opacity: 1;
  }
}
</style>